// extracted by mini-css-extract-plugin
export default {"dialogBody":"NoticiasEventos_dialogBody__4J86r","dialogImgDiv":"NoticiasEventos_dialogImgDiv__3UjAC","dtmoodCardImage":"NoticiasEventos_dtmoodCardImage__H-VNS"};